import { Component, Input, type OnInit } from '@angular/core'
import { BdcContentV2Service, BdcFacilityState } from '@tokeet-frontend/channel-content'
import { combineLatest } from 'rxjs'
import * as lodash from 'lodash'
import { FormArray, FormBuilder, FormGroup } from '@angular/forms'
import { finalize } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { ActionFailed, Toaster } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-bdc-property-unit-amenities',
  templateUrl: './bdc-property-unit-amenities.component.html',
})
export class BdcPropertyUnitAmenitiesComponent implements OnInit {
  @Input() propertyId: number
  @Input() roomId: number

  amenitiesForm = this.fb.group({
    amenities: this.fb.array([]),
  })

  get amenitiesArray() {
    return this.amenitiesForm.get('amenities') as FormArray
  }

  isLoading = true
  constructor(
    private fb: FormBuilder,
    private toaster: Toaster,
    private store: Store<any>,
    private contentService: BdcContentV2Service
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.contentService.getRoomAmenities(),
      this.contentService.getRoomFacilities(this.propertyId, this.roomId),
    ])
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        ([amenities, facilities]) => {
          this.amenitiesArray.clear()
          const facilitiesById = lodash.keyBy(facilities, (f) => f.room_facility_id) as any

          lodash
            .sortBy(amenities, (t) => t.room_facility_name)
            .forEach((a) => {
              const f = facilitiesById[a.room_facility_id]
              this.amenitiesArray.push(
                this.fb.group({
                  id: a.room_facility_id,
                  name: a.room_facility_name,
                  enabled: /present/i.test(f?.state || ''),
                })
              )
            })
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onToggleItem(item: FormGroup, checked: boolean) {
    const id = item.value.id
    const data = {
      room_facility_id: id,
      state: checked ? BdcFacilityState.PRESENT : BdcFacilityState.MISSING,
    }
    this.contentService.updateRoomFacilities(this.propertyId, this.roomId, [data]).subscribe(
      () => {
        this.toaster.success($localize`Amenities updated successfully`)
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }
}
